import {
  IPaymentHistoryResponse,
  IPaymentHistoryResponseWithTranslations,
} from "../fetchPaymentHistory/types";
import { IPayment, IPaymentWithTranslations } from "../types";
import { IPaymentsTranslationsResponse } from "./types";

export function mergePaymentWithTranslations(
  payments: IPayment[],
  translations: IPaymentsTranslationsResponse,
): IPaymentHistoryResponseWithTranslations["payments"] {
  const result: IPaymentHistoryResponseWithTranslations["payments"] = [];
  for (const paymentItem of payments) {
    const payment: IPaymentWithTranslations = {
      ...paymentItem,
      name: "",
      icon: "",
    };
    const items: IPaymentHistoryResponse["payments"][0]["paymentItem"] = [];

    for (const item of payment.paymentItem) {
      const paymentOfferingId = item.productOfferingId;
      const translatedName = translations[paymentOfferingId] as
        | string
        | undefined;
      const translatedIcon = translations.icon[paymentOfferingId] as
        | string
        | undefined;

      if (payment.type === "PAYMENT") {
        item.name = translatedName || translations.defaultPayment;
        item.icon = translatedIcon || translations.icon.defaultPayment;
      }
      if (payment.type === "REFUND") {
        item.name = translatedName || translations.defaultRefund;
        item.icon = translatedIcon || translations.icon.defaultRefund;
      }
      items.push(item);
    }
    const isJustSingleItem = items.length === 1;
    if (!isJustSingleItem) {
      if (payment.type === "PAYMENT") {
        payment.name = translations.defaultPayment;
        payment.icon = translations.icon.defaultPayment;
      }
      if (payment.type === "REFUND") {
        payment.name = translations.defaultRefund;
        payment.icon = translations.icon.defaultRefund;
      }
    } else {
      if (items[0].name) {
        payment.name = items[0].name;
      }
      if (items[0].icon) {
        payment.icon = items[0].icon;
      }
    }
    result.push({ ...payment, paymentItem: items });
  }
  return result;
}
